import React, {Component} from 'react';
import {makeCancelable} from "../../utils/PromiseUtils";
import T from "i18n-react";
//Components
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
//Services
import ShopService from "../../services/ShopService";
// Enums
import LOCATIONS from '../../enums/Location';
//Style
import "./ShopCard.css";

class ShopCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            buList: [],
            contractList: [],
            passList: [],
            error: null,
            isLoaded: false,
            idShop: props.shop.id
        };

        this._promises = [];
        this.getShopAssociations();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.shop!==this.props.shop){
            this.getShopAssociations();
            this.setState({isLoaded: false});
        }
    }

    /**
     * Annulation de toutes les promesses encore en cours lorsque
     * l'on quitte le composant
     */
    componentWillUnmount() {
        this._promises.forEach(promise => promise.cancel());
    }

    render() {
        return (
            <div className="shopCard">
                <IconButton className="closeButton" onClick={this.props.closeCard}>
                    <CloseIcon />
                </IconButton>
                <span className="cardTitle"><b>{this.props.shop.name}</b>{" - "+  this.props.shop.codeAl}</span>
                { this.state.isLoaded ?
                    <div className="cardContent">
                        <div className="cardBlock">
                            <span className="cardSubTitle">{T.translate('shopPage.associatedContract')}</span>
                            {this.renderContractList(this.state.contractList)}
                        </div>
                        {this.renderBuInfos(this.state.buList)}
                        <div className="cardBlock">
                            <span className="cardSubTitle">
                                {T.translate("tableFields." + ShopService.getShopLocationSpecificCodeLabel(this.props.shop.location)) + " - "}
                                <b>{ShopService.getShopLocationSpecificCodeValue(this.props.shop)}</b>
                            </span>
                            {this.props.shop.location === LOCATIONS.FR ? this.renderShopPassHistory(this.state.passList) : null}
                        </div>
                    </div>
                    : null
                }
            </div>
        );
    }

    renderContractList(contractList){
        return (
            <div>
                <ul>
                    {contractList.map((value, index) => <li key={index}> {value.contractNumber} </li> )}
                </ul>
            </div>
        )
    }

    renderShopPassHistory(shopPassList){
        if(shopPassList){
            shopPassList = shopPassList.filter(shopPass => shopPass.endDate != null);
            if(shopPassList.length > 0){
                return (
                    <div>
                        <ul>
                            {shopPassList.map((value, index) => this.renderShopCodePassAssociation(value, index))}
                        </ul>
                    </div>
                )
            } else {
                return <div className="emptyHistory">{T.translate('shopPage.emptyHistory')}</div>
            }
        } else {
            return null;
        }
    }

    renderShopCodePassAssociation(association, index){
        return (
            <li key={index}>
                {association.codePass + " : " + T.translate('shopPage.until') + " " + association.endDate}
            </li>
        );
    }

    renderBuInfos(buList){
        const activeBu = buList.find(item => item.endDate == null).businessUnit;
        buList = buList.filter(item => item.endDate != null);
        return (
            <div className="cardBlock">
                <span className="cardSubTitle">
                    {T.translate('shopPage.activeBu') +" : "}<b>{activeBu.name}</b>
                </span>
                { activeBu.cif ?
                    <span className="cardSubTitle">{T.translate('shopPage.codeCif') +" : "} <b>{activeBu.cif}</b></span>
                    : null
                }
                { buList.length > 0 ?
                    <div className="buHistory">
                        <span className="cardSubTitle">{T.translate('shopPage.buHistory') +" : "}</span>
                        <ul>
                            {buList.map((value, index) => this.renderBuAssociation(value, index))}
                        </ul>
                    </div>
                    : null
                }

            </div>
        )
    }

    renderBuAssociation(value, index){
        return (
            <li key={index}>
                {value.businessUnit.codeBu + " - " + value.businessUnit.name + " : " +T.translate('shopPage.until') + " " + value.endDate}
            </li>
        );
    }

    /**********************************************************
     * **************** Appels Web Service ********************
     **********************************************************/

    getShopAssociations = () => {
        const getShopPassListPromise = ShopService.getShopAssociations(this.props.shop.id);

        const cancelablePromise = makeCancelable(getShopPassListPromise);
        this._promises.push(cancelablePromise);

        cancelablePromise
            .promise
            .then(res => {
                this.setState({
                    buList: res.buAssociationList,
                    contractList: res.contractAssociationList,
                    passList: res.passAssociationList,
                    isLoaded: true
                })
            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({
                        error
                    });
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
    };

    /**********************************************************
     * ************** Gestion des promises ******************
     **********************************************************/

    /**
     * On retire la promise de la liste des promises en cours
     * Cette fonction doit etre appelé après que la promise est rempli
     * @param promise
     */
    promiseFulfilled(promise) {
        const index = this._promises.indexOf(promise);

        if (index !== -1) {
            this._promises.splice(index, 1);
        }
    };
}

export default ShopCard;


// WEBPACK FOOTER //
// ./src/components/shopCard/ShopCard.js